<template>
  <el-row align="middle" class="boxTit size12 backF">
    <el-row type="flex" align="middle">
      <el-row type="flex" class="flex-wrap" style="margin-top: -10px">
        <!-- <el-input size="small" v-model.trim="form.KeyWords" style="width: 500px;"  placeholder="可输入订单号、VAT No.或税号搜索..." @keyup.enter.native="enterToSearch" ></el-input> -->
        <el-row v-for="field in searchMainFields" :key="field.name" class="marRight10 marTop10">
          <template v-if="field.type === 'input'">
            <el-input
              v-model="form[field.name]"
              size="small"
              class="key-word-input"
              clearable
              :style="{ width: (field.width || width) }"
              :placeholder="field.placeholder"
              @keyup.enter.native="enterToSearch"
            />
          </template>
          <template v-else-if="field.type === 'data'">
              <el-date-picker
                v-model="form[field.name]"
                size="small"
                align="right"
                type="date"
                :style="{ width: (field.width || '130px') }"
                :placeholder="field.placeholder"
                :picker-options="pickerOptions1">
              </el-date-picker>
          </template>
          <template v-else-if="field.type === 'data1'">
              <el-date-picker
                v-model="form[field.name]"
                size="small"
                align="right"
                type="date"
                :style="{ width: (field.width || '130px') }"
                :placeholder="field.placeholder"
                :picker-options="pickerOptions2">
              </el-date-picker>
          </template>
          <template v-else-if="field.type === 'data-picker'">
            <el-row>
              <el-date-picker
                v-model="form[field.name1]"
                size="small"
                align="right"
                type="date"
                :style="{ width: (field.width || '130px') }"
                :placeholder="field.placeholder"
                @change="(time) => checkTimeFn(time, field)"
                :picker-options="pickerOptions1">
              </el-date-picker>
              <i class="colorDC"> — </i>
              <el-date-picker
                v-model="form[field.name2]"
                size="small"
                align="right"
                type="date"
                :style="{ width: (field.width || '130px') }"
                :placeholder="field.placeholder"
                @change="(time) => checkTimeFn(time, field)"
                :picker-options="pickerOptions1">
              </el-date-picker>
            </el-row>
          </template>
          <template v-else-if="field.type === 'select'">
            <el-select
              v-if="field.type === 'select'"
              v-model="form[field.name]"
              clearable
              size="small"
              :placeholder="field.placeholder"
              :style="{ width: (field.width || '150px') }"
            >
              <el-option
                v-for="item in field.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
          <template v-else-if="field.type === 'select-filterable'">
            <el-select
              v-model="form[field.name]"
              filterable
              clearable
              size="small"
              :placeholder="field.placeholder"
              :style="{ width: (field.width || '150px') }"
            >
              <el-option
                v-for="item in field.options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-row>
        <el-row>
          <el-button type="primary" size="small" class="butt_search_W size12 colorF marRight10 marTop10" @click="handleSubmit">搜索</el-button>
          <span @click="searchJX = !searchJX" class="size12 color26 pointer more-search marTop10" v-show="isShowMoreSearch">
            <i v-show="searchJX">精简筛选条件</i>
            <i v-show="!searchJX">更多筛选条件</i>
            <i :class="{'el-icon-caret-top': searchJX,'el-icon-caret-bottom': !searchJX}"></i>
          </span>
        </el-row>
      </el-row>
      <el-row style="margin-left:auto">
          <slot name="btn"></slot>
        </el-row>
    </el-row>
    <el-collapse-transition>
      <div v-show="searchJX" class="borderTopF2  marTop20">
        <el-row class="marRight10" type="flex" align="middle" style="flex-wrap: wrap">
          <el-row class="marTop20 marRight10" v-for="field in searchOtherFields" :key="field.name">
            <el-row class="size12 marBott5" v-show="isShowLabel">{{field.label}}</el-row>
              <el-input
                v-if="field.type === 'input'"
                v-model="form[field.name]"
                size="small"
                clearable
                :style="{ width: (field.width || width) }"
                :placeholder="field.placeholder"
              />
              <el-checkbox 
                v-if="field.type === 'checkbox'" 
                v-model="form[field.name]" 
                size="small"
                :style="{ width: (field.width || width) }"
                >{{field.placeholder}}</el-checkbox>
              <el-row v-if="field.type === 'data'">
                <el-date-picker
                  v-model="form[field.name]"
                  size="small"
                  align="right"
                  type="date"
                  :style="{ width: (field.width || '130px') }"
                  :placeholder="field.label"
                  :picker-options="pickerOptions1">
                </el-date-picker>
              </el-row>
              <el-row v-if="field.type === 'data-picker'">
                <el-date-picker
                  v-model="form[field.name1]"
                  size="small"
                  align="right"
                  type="date"
                  :style="{ width: (field.width || '130px') }"
                  :placeholder="field.label"
                  @change="() => checkTimeFn(field)"
                  :picker-options="pickerOptions1">
                </el-date-picker>
                <i class="colorDC"> — </i>
                <el-date-picker
                  v-model="form[field.name2]"
                  size="small"
                  align="right"
                  type="date"
                  :style="{ width: (field.width || '130px') }"
                  :placeholder="field.placeholder"
                  @change="() => checkTimeFn(field)"
                  :picker-options="pickerOptions1">
                </el-date-picker>
              </el-row>
              <el-row v-if="field.type === 'more-data-picker'">
                <el-select
                  v-model="form[field.name]"
                  size="small"
                  style="width: 100px;"
                  class="marRight10"
                  @change="changeTimeSelect"
                >
                  <el-option
                    v-for="item in field.options"
                    :key="item.label"
                    :label="item.label"
                    :value="item.type">
                  </el-option>
                </el-select>

                <el-date-picker
                  v-model="form[field.name1]"
                  size="small"
                  align="right"
                  type="date"
                  :style="{ width: (field.width || '130px') }"
                  :placeholder="'请选择日期'"
                   @change="() => checkTimeFn(field)"
                  :picker-options="pickerOptions1">
                </el-date-picker>
                <i class="colorDC"> — </i>
                <el-date-picker
                  v-model="form[field.name2]"
                  size="small"
                  align="right"
                  type="date"
                  :style="{ width: (field.width || '130px') }"
                  :placeholder="'请选择日期'"
                  @change="() => checkTimeFn(field)"
                  :picker-options="pickerOptions1">
                </el-date-picker>
              </el-row>

              <el-select
                v-if="field.type === 'select'"
                v-model="form[field.name]"
                clearable
                size="small"
                @change="() => checkPayFn(field)"
                :placeholder="field.placeholder"
                :style="{ width: (field.width || width) }"
              >
                <el-option
                  v-for="item in field.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <template v-if="field.type === 'select-filterable'">
                <el-select
                  v-model="form[field.name]"
                  filterable
                  clearable
                  size="small"
                  :placeholder="field.placeholder"
                  :style="{ width: (field.width || '150px') }"
                >
                  <el-option
                    v-for="item in field.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
          </el-row>
        </el-row>
      </div>
    </el-collapse-transition>
  </el-row>
</template>

<script>
export default {
  name: 'SearchForm',
  props: {
    searchMainFields: {
      type: Array,
      default () {
        return [
          // { type: 'input', label: '注册主体', name: 'RegisterMain', placeholder: '应用名称' },
          // { type: 'data-picker', label: '选择日期', name1: 'data', name2: 'data', placeholder: '选择日期' },
          // {
          //   type: 'select',
          //   label: '应用类型',
          //   name: 'appType',
          //   placeholder: '选择应用类型',
          //   options: [
          //     { label: '全部', value: '' },
          //     { label: '我的应用', value: 1 },
          //     { label: '第三方应用', value: 2 }
          //   ]
          // }
        ]
      }
    },
    searchOtherFields: {
      type: Array,
      default () {
        return []
      }
    },
    width: {
      type: String,
      default: '150px'
    },
    isShowLabel: {
      type: Boolean,
      default: false
    },
    isShowAd: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowMoreSearch: false,
      searchJX: false,
      mainFields: [],
      otherFields: [],
      form: {},
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions2: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      isSaasSystem: false,
    }
  },
  mounted () {
    if (window.parent.systemCode === 'saas') {
      this.isSaasSystem = true
    }
  },
  methods:{
    initMain () {
      const { searchMainFields } = this
      const form = {}
      if (searchMainFields.length > 0) {
        searchMainFields.forEach(item => { // 给表单赋值
          if (item.hasOwnProperty('value')) {
            if (item.type === 'data-picker') {
              form[item.name1] = item.value1 || ''
              form[item.name2] = item.value2 || ''
            } else if (typeof(item.value) === 'boolean') {
              form[item.name] = item.value
            } else {
              form[item.name] = item.value || ''
            }
          }
        })
      }
      this.form = { ...this.form, ...form }
    },
    initOther () {
      const { searchOtherFields } = this
      const form = {}

      if (searchOtherFields.length > 0) {
        searchOtherFields.forEach(item => { // 给表单赋值
          if (item.type === 'more-data-picker') {
              form[item.name] = item.value
              form[item.name1] = item.value1
              form[item.name2] = item.value2
          }
          if (item.hasOwnProperty('value')) {
            if (item.type === 'data-picker') {
              form[item.name1] = item.value1 || ''
              form[item.name2] = item.value2 || ''
            } else if (typeof(item.value) === 'boolean') {
              form[item.name] = item.value
            } else {
              form[item.name] = item.value || ''
            }
          }
        })
        this.isShowMoreSearch = true
      }
      this.form = { ...this.form, ...form }
    },
    checkPayFn(){
      return this.$emit('payMent',this.form.paymentMethod)
    },
    // check 时间
    checkTimeFn(field) {
      let sTime = this.form[field.name1]
      let eTime = this.form[field.name2]
      let startTime = new Date(sTime).getTime()
      let endTime = new Date(eTime).getTime()
      if (startTime && endTime && startTime > endTime) {
        this.$message({
          message: '申请注册日期的起始日期不能大于结束日期',
          type: 'warning'
        })
        return false
      }
      return true
    },
    enterToSearch(e) {
      var keyCode = window.event? e.keyCode : e.which;
      if(keyCode == 13){
        this.handleSubmit()
      }
    },
    changeTimeSelect () {
      this.searchOtherFields.forEach(item => { // 多时间选择处理
        if (item.type === 'more-data-picker') {
          item.options.forEach(it => { // 把其他时间都清空
            this.form[it.name1] = undefined
            this.form[it.name2] = undefined
          })
        }
      })
    },
    handleSubmit () {
      console.log(this.form)
      this.$emit('submit', this.form)
    }
  },
   watch: {
    searchMainFields: {
      handler: 'initMain',
      immediate: true
    },
    searchOtherFields: {
      handler: 'initOther',
      immediate: true
    }
  }
}
</script>

<style scoped>
.ad-box {
  margin-left:auto
}
.ad-box img {
  border-radius: 8px;
}
@media  screen and (max-width: 1480px) {
  .key-word-input {
    max-width: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vueModel/SearchForm/SearchForm.vue